module.exports = __webpack_public_path__ + "img/laptop-w-background-1920.c4e6bdf.webp";